export default __webpack_public_path__ + "img/8151b079575b03c6f523d1a5bdef88ca.svg";